import React from "react";
import { formatDate } from "../../utils/dates";
import { useNavigate } from "react-router-dom";
import GenericAvatar from "../AIInbox/GenericAvatar";
import IconButtonSecondary from "../../components/IconButtonSecondary";
import {
  CheckCircleIcon,
  EllipsisHorizontalIcon,
  EnvelopeOpenIcon,
  EyeIcon,
} from "@heroicons/react/24/outline";
import truncateString from "../../utils/truncateString";

const ItemBox = ({
  task,
  setIsModalVisible,
  setSingleTask,
  handleConversation,
}) => {
  const navigate = useNavigate();

  const viewConversation = () => {
    navigate(`/dashboard/ai-inbox?only=${task?.conversation_uuid}`);
  };

  const taskSummary = task?.summary || "N/A";

  const [summary, followUp] = taskSummary
    .replace("Follow-up action: ", "")
    .replace("Summary: ", "")
    .split("\n\n");

  const onClick = () => {
    setSingleTask(prevState => ({
      ...prevState,
      task,
    }));
    setIsModalVisible(true);
  };

  if (!task) return null;

  return (
    <div className="p-4 bg-white border rounded-lg shadow-sm space-y-2">
      <div className="flex items-center space-x-4 w-full">
        <div className="w-10 h-10 bg-gray-200 flex items-center justify-center rounded-full text-gray-600 font-semibold">
          <GenericAvatar
            firstName={task.customer?.first_name}
            lastName={task.customer?.last_name}
          />
        </div>
        <div className="flex items-center space-x-2">
          <span className="font-medium text-gray-800">
            {task.customer?.first_name + " " + task.customer?.last_name}
          </span>
          <span className="text-sm text-gray-500">
            {formatDate(task.last_message_time)}
          </span>
        </div>
      </div>

      <div className="flex justify-between items-start sm:flex-row flex-col gap-4">
        <div>
          {Boolean(summary || followUp) && (
            <div className="flex flex-col">
              {summary && (
                <button type="button" onClick={onClick}>
                  <h3 className="text-slate-700 mb-1 text-sm text-left">
                    {truncateString(summary, 50)}
                  </h3>
                </button>
              )}

              {followUp && (
                <button type="button" onClick={onClick}>
                  <p className="text-sm text-slate-900 font-semibold text-left">
                    {truncateString(followUp, 100)}
                  </p>
                </button>
              )}
            </div>
          )}

          <div className="flex items-center space-x-2">
            <span className="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded-full">
              Ticket #{task.conversation_id}
            </span>
            <span
              className={`text-xs ${task.resolved ? `bg-blue-100 text-blue-600` : `bg-orange-100 text-orange-600`} px-2 py-1 rounded-full`}
            >
              {task.resolved ? `Closed` : `Open`}
            </span>

            {[
              ...new Map(task.intents.map(item => [item.type, item])).values(),
            ].map((intent, index) => {
              return (
                <button
                  key={`${intent.id}-${index}`}
                  className="text-xs bg-green-100 text-green-600 px-3 py-1.5 rounded-full hover:bg-green-200"
                >
                  {intent.type}
                </button>
              );
            })}
          </div>
        </div>

        <div className="flex items-center space-x-3">
          <IconButtonSecondary
            onClick={() => {
              setSingleTask(prevState => ({
                ...prevState,
                task,
              }));
              setIsModalVisible(true);
            }}
          >
            <EllipsisHorizontalIcon className="size-6" />
          </IconButtonSecondary>

          <IconButtonSecondary onClick={() => viewConversation()}>
            <EyeIcon className="size-6" />
          </IconButtonSecondary>

          <IconButtonSecondary onClick={() => handleConversation(task)}>
            {task.resolved ? (
              <EnvelopeOpenIcon className="size-6" title="Re-open Ticket" />
            ) : (
              <CheckCircleIcon className="size-6" title="Resolve Ticket" />
            )}
          </IconButtonSecondary>
        </div>
      </div>
    </div>
  );
};
export default ItemBox;
